<script>
import { Line, mixins } from "@/utils/BaseCharts"
const { reactiveProp } = mixins

export default {
    extends: Line,
    mixins: [reactiveProp],
    props: ["options"],
    data() {
        return {
            gradient: null,
        }
    },
    watch: {
        chartData: {
            handler: function () {
                this.$data._chart.config.data.datasets[0].borderColor = this.gradient
                this.$data._chart.config.data.datasets[0].backgroundColor = "rgba(0,0,0,0)"
                this.$data._chart.update()
            },
        },
    },
    mounted() {
        this.gradient = this.$refs.canvas.getContext("2d").createLinearGradient(0, 0, 0, 350)

        this.gradient.addColorStop(0, "rgb(244, 94, 65)")
        this.gradient.addColorStop(1, "rgb(66, 92, 244)")

        this.chartData.datasets[0].backgroundColor = "rgba(0,0,0,0)"
        this.chartData.datasets[0].borderColor = this.gradient

        this.renderChart(
            this.chartData,
            Object.assign({ responsive: true, maintainAspectRatio: false }, this.options)
        )
    },
}
</script>
